import styled from 'styled-components';

export default styled('div')`
  display: flex;
  width: ${props => `calc(100%/16*${props.width})`}
`;
